import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { SettingsService } from '../settings/settings.service';
import { SessionService } from './session.service';
import { defineAbilityFor } from '../../core/permissions/role-permissions';
import { Subject } from '../../core/permissions/app-ability';

/**
 * Route guard driven by the centralised CASL ability.
 *
 * Set `data: { subject: 'Tables' }` on a route to protect it.
 * The guard checks whether the current assumed role can `read` that subject.
 */
export const roleGuard: CanActivateFn = (route) => {
    const router   = inject(Router);
    const devMode  = inject(SettingsService).devMode;
    const subject  = route.data?.['subject'] as Subject | undefined;

    if (devMode || !subject) return true;

    return inject(SessionService).assumedRole$.pipe(
        map(role => {
            const ability = defineAbilityFor(role);
            return ability.can('read', subject)
                ? true
                : router.createUrlTree(['/']);
        }),
    );
};
